import React from 'react';
import { Link } from 'react-router-dom';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';

export default class SuggestionsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableVisible: false
        };
    }

    toggleTableView() {
        this.setState({ tableVisible: !this.state.tableVisible });
    }

    onClick = (suggestion) => {
        if (!suggestion.incomplete || this.props.allowIncomplete) this.props.suggestionSelected(suggestion);
    }

    render() {
        return (
            <div className='column-two-thirds'>
                <div className="suggestions-select-container accent-box-container">
                    <div className="suggestion-select accent-box">
                        <i className="icon ion-android-warning" />
                        <p className="inline-block">We found {this.props.suggestions.length} {this.props.suggestions.length === 1 ? 'suggestion' : 'suggestions'}</p>
                        <i onClick={this.toggleTableView.bind(this)} className={this.state.tableVisible ? "icon ion-ios-arrow-up" : "icon ion-ios-arrow-down"} />
                    </div>
                    {this.state.tableVisible &&
                        <div className="suggestion-select-box">
                            <table>
                                <tbody>
                                    {this.props.suggestions.map(s =>
                                        <HoverTableRow key={s.applicantId} onClick={() => this.onClick(s)} disabled={s.incomplete && !this.props.allowIncomplete}>
                                            <td className="bold-text">
                                                <span className="block">{s.name}</span>
                                                {s.incomplete && <span className="tag incomplete">Incomplete</span>}
                                            </td>
                                            <td>{s.address}</td>
                                            <td style={{width: "128px"}}><p className="suggestions-phone-number">{s.phoneNumber.join(" | ")}</p></td>
                                            <td className="text-center"><Link className="btn btn-primary input" target={"_blank"} to={`/recipient-accounts/${s.applicantId}`}>View</Link></td>
                                        </HoverTableRow>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/SuggestionsTable.jsx